import { MetricId } from '../../common/components/metrics/types';
import { memoizeByReference } from '../../common/utils';
import { MetricCategoryId, MetricGroupId } from '../types-graphql';
import {
  MetricCategoryDetails,
  MetricDetails,
  MetricGroupDetails,
  MetricTree,
} from './types';

export const metricTreeToMetricDetailsMap = memoizeByReference(
  (metricTree: MetricTree) => {
    return Object.fromEntries(
      metricTree.groupDetails.flatMap((m) => {
        return m.dimensions.map((d) => {
          return [d.id, d];
        });
      }) ?? []
    ) as Record<MetricId, MetricDetails>;
  }
);

export const metricTreeToMetricGroupDetailsMap = memoizeByReference(
  (metricTree: MetricTree) => {
    return Object.fromEntries(
      metricTree.groupDetails.map((group) => {
        return [group.id, group];
      }) ?? []
    ) as Record<MetricGroupId, MetricGroupDetails>;
  }
);

export const metricTreeToMetricCategoryDetailsMap = memoizeByReference(
  (metricTree: MetricTree) => {
    return Object.fromEntries(
      metricTree.categoryDetails.map((category) => {
        return [category.id, category];
      }) ?? []
    ) as Record<MetricCategoryId, MetricCategoryDetails>;
  }
);
